var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form-item",
        { attrs: { label: _vm.i18nt("designer.setting.topMargin") } },
        [
          _c("el-input-number", {
            staticClass: "hide-spin-button",
            attrs: { min: 0 },
            model: {
              value: _vm.optionModel.topMargin,
              callback: function ($$v) {
                _vm.$set(_vm.optionModel, "topMargin", _vm._n($$v))
              },
              expression: "optionModel.topMargin",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }